export default[
    {
        path: '/reintegracao/trabalhador/cadastro/:trabalhador_id',
        name: 'cadastro do reintegracao do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/reintegracao/trabalhador/lista',
        name: 'lista de reintegracao do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/reintegracao/trabalhador/editar/:id/:trabalhador_id',
        name: 'editar reintegracao do trabalhador', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]